module.exports = __webpack_public_path__ + "static/media/sensei-mj.fbc91ea1.jpg";